export default {
    supportKindCode: 'RMB_SUPPORT_PAYMENT',
    expenseAmount: "RMB_SUPPORT_PAYMENT_STATIC1",
    removed: {
        mandatoryEndDate: 'RMB_SUPPORT_PAYMENT_STATIC2'
    } 
}